import { HTMLAttributes } from "react";

interface ImagePatternProps extends HTMLAttributes<HTMLDivElement> {}

const ImagePattern = ({ ...props }: ImagePatternProps) => {
  return (
		<div {...props} id='image-pattern-before-after'>
			<span className='font-bold uppercase absolute bottom-0 left-0 text-white pb-0 pl-[0.625rem] text-[0.875rem]'>
				Before
			</span>
			<span className='font-bold uppercase absolute bottom-0 right-0 text-white pb-0 pr-[0.625rem] text-[0.875rem]'>
				After
			</span>
			{/* <span className="absolute top-0 left-1/2 bg-white h-full w-1 transform -translate-x-1/2" /> */}
		</div>
	)
};

export default ImagePattern;
